const LargePlusIcon = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8C2 7.63181 2.29848 7.33333 2.66667 7.33333H13.3333C13.7015 7.33333 14 7.63181 14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667H2.66667C2.29848 8.66667 2 8.36819 2 8Z"
        fill="#A8A8BB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8.36819 2 8.66667 2.29848 8.66667 2.66667V13.3333C8.66667 13.7015 8.36819 14 8 14C7.63181 14 7.33333 13.7015 7.33333 13.3333V2.66667C7.33333 2.29848 7.63181 2 8 2Z"
        fill="#A8A8BB"
      />
    </svg>
  );
};

export default LargePlusIcon;
